<template>
  <div class="card">
    <div class="card-header pb-0">
      <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Admin Accounts</span>
      <span class="text-secondary text-xs">Press view on the account above that you want to edit.</span>
      <span style="float: right">
        <argon-button @click="openEditor('createAdmin')" color="success" size="md">Add Admin</argon-button>
      </span>
    </div>

    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-6">Account Name</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-5">Events</th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(admin, index) in getAdminAccounts.rows">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <img src="https://www.svgrepo.com/show/55152/account.svg" class="avatar avatar-sm me-3 avatar-admin" alt="user1" />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ admin.full_name }}</h6>
                    <p class="text-xs text-secondary mb-0">Created: {{ formatDate(admin.createdAt) }} | Updated: {{ formatDate(admin.updatedAt) }} | Email: {{ admin.email }}</p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="badge badge-sm bg-gradient-secondary">No Events Assigned</span>
              </td>
              <td class="align-middle">
                <a href="javascript:;" @click="this.openEditor('viewAdmin', index)" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">View</a>
                <a href="javascript:;" @click="deleteAdminAccount(admin.id, admin.full_name)" class="text-danger font-weight-bold text-xs mx-5" data-toggle="tooltip" data-original-title="Edit user">Delete</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  import ArgonButton from "@/components/ArgonButton.vue";

  export default {
    name: "authors-table",
    components: {
      ArgonButton,
    },
    data() {
      return {};
    },
    computed: {
      getAdminAccounts() {
        return this.$store.state.adminlist;
      },
    },
    methods: {
      getAllAdmin() {},
      formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [day, month, year].join("/");
      },
      openEditor(mode, row) {
        var editorData = { isOpen: true, mode: mode, requestedrow: row };
        this.$store.state.accountEditor = editorData;
        console.log(this.$store.state.accountEditor);
      },
      deleteAdminAccount(id, full_name) {
        let JWTToken = localStorage.getItem("token");

        if (confirm("Delete Account : " + full_name + "?")) {
          axios
            .delete("https://api.macra.co.id/mavent/admin/delete/" + id, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {})
            .catch((error) => {});
          alert("Account Deleted");
          location.reload();
        } else {
          // Do nothing!
        }
      },
    },
    created() {
      let JWTToken = localStorage.getItem("token");

      axios
        .get("https://api.macra.co.id/mavent/admin/all", { headers: { Authorization: `Bearer ${JWTToken}` } })
        .then((res) => {
          this.$store.state.adminlist = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  };
</script>

<style scoped>
  .avatar-admin {
    filter: invert(72%) sepia(20%) saturate(921%) hue-rotate(133deg) brightness(92%) contrast(93%);
  }
</style>
